export default __webpack_public_path__ + "static/media/welcome.d00b1931.csv";